// Environment configuration
const stripTrailingSlashes = (value: string): string => value.replace(/\/+$/, '');

export const API_CONFIG = {
  BASE_URL: stripTrailingSlashes(process.env.REACT_APP_API_BASE_URL || '/api'),
  // Some backend endpoints (e.g. `/api/Auth/Login`) require an API key header.
  // iFrame uses `X-COR-ApiKey`; we also send `apiKey` for backends that bind that parameter name.
  COR_API_KEY: process.env.REACT_APP_COR_API_KEY || '',
  AUTH_LOGIN_ENDPOINT: process.env.REACT_APP_AUTH_LOGIN_ENDPOINT || '/Auth/login',
  AUTH_REGISTER_ENDPOINT: process.env.REACT_APP_AUTH_REGISTER_ENDPOINT || '/Auth',
  AUTH_REFRESH_ENDPOINT: process.env.REACT_APP_AUTH_REFRESH_ENDPOINT || '/Auth/refresh-token',
  AUTH_CHANGE_PASSWORD_ENDPOINT: process.env.REACT_APP_AUTH_CHANGE_PASSWORD_ENDPOINT || '/Auth/change-password',
  AUTH_FORGOT_PASSWORD_ENDPOINT: process.env.REACT_APP_AUTH_FORGOT_PASSWORD_ENDPOINT || '/Auth/forgot-password',
  AUTH_RESET_PASSWORD_ENDPOINT: process.env.REACT_APP_AUTH_RESET_PASSWORD_ENDPOINT || '/Auth/reset-password',
  USERS_ENDPOINT: process.env.REACT_APP_USERS_ENDPOINT || '/Users',
  TRANSACTIONS_ENDPOINT: process.env.REACT_APP_TRANSACTIONS_ENDPOINT || '/Transactions',
  EXCHANGE_API_KEY: process.env.REACT_APP_EXCHANGE_API_KEY || '9366e355b8431a54128d03fd',
};


/** Absolute API base URL for display (iframe docs, payment-link endpoint text). */
export const getApiBaseUrl = (): string => {
  const base = API_CONFIG.BASE_URL;
  if (/^https?:\/\//i.test(base)) return base;
  const path = base.startsWith('/') ? base : `/${base}`;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return path;
};

export const API_ENDPOINTS = {
  LOGIN: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_LOGIN_ENDPOINT}`,
  REGISTER: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_REGISTER_ENDPOINT}`,
  REFRESH_TOKEN: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_REFRESH_ENDPOINT}`,
  AUTH_CHANGE_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_CHANGE_PASSWORD_ENDPOINT}`,
  AUTH_FORGOT_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_FORGOT_PASSWORD_ENDPOINT}`,
  AUTH_RESET_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_RESET_PASSWORD_ENDPOINT}`,
  USERS: `${API_CONFIG.BASE_URL}${API_CONFIG.USERS_ENDPOINT}`,
  TRANSACTIONS: `${API_CONFIG.BASE_URL}${API_CONFIG.TRANSACTIONS_ENDPOINT}`,
  SETTINGS_FEES: `${API_CONFIG.BASE_URL}/settings/fees`,
};
